import { useMyStyle } from "../../../js/api/my-style/post-my-style";
import { SharedIcon } from "../shared/shared-icon";
import { useMyStyleContext } from "../../my-style";

export const MyStyleModal = ({ closeModal, error }) => {
  const { data, isLoading, isSuccess } = useMyStyle();
  const { header } = useMyStyleContext();

  if (error) {
    return (
      <div className="my-style__error-container">
        <h3 className="my-style__error-header">{header}</h3>

        <ul className="my-style__error-wrapper">
          {Object.values(error.response.data).map((errors) =>
            errors.map((error, index) => (
              <li key={index} className="my-style__error">
                {error}
              </li>
            ))
          )}
        </ul>
      </div>
    );
  }

  if (isLoading || !isSuccess) {
    return (
      <div className="saved-colors-loading-container">
        <SharedIcon iconName="#sprite-spinner" className="animate-spin" />
      </div>
    );
  }

  return (
    <>
      <div className="my-style__header">
        <h3 className="my-style__header-title">your style</h3>
      </div>
      <div className="my-style__main">
        <div className="my-style__content-wrapper">
          <p className="my-style__my-personality">
            <span className="my-style__my-personality--bold">
              {data.personalityType}
            </span>
          </p>

          {data.styleWords && data.styleWords.length > 0 && (
            <div className="my-style__picked-tags">
              {data.styleWords.map((word) => (
                <span key={word}>{word}</span>
              ))}
            </div>
          )}

          <div className="my-style__personality">
            {data.roomTypes &&
              data.roomTypes.length > 0 &&
              data.roomTypes.map((room) => (
                <img key={room.url} src={room.url} alt={room.label} />
              ))}

            {data.colourTypes &&
              data.colourTypes.length > 0 &&
              data.colourTypes.map((colour) => (
                <img key={colour.url} src={colour.url} alt={colour.label} />
              ))}
          </div>
        </div>
      </div>
      <div className="my-style__footer">
        <div className="my-style__buttons-wrapper">
          <button className="my-profile__submit-button" onClick={closeModal}>
            Back
          </button>

          <button
            className="my-profile__submit-button my-profile__submit-button--dark"
            onClick={() => {
              closeModal();
              document.getElementById("my-profile__form--my-style").submit();
            }}
          >
            Save style
          </button>
        </div>
      </div>
    </>
  );
};
